<fieldset class="panel">
  <div class="text-center">
    <span class="situacao">Pedido de Exame - {{ marcacaoAtual.data_Comparecimento | date: 'dd/MM/yyyy' }} {{
      marcacaoAtual.isTravada ? 'Travado' : '' }}</span>
    <button class="btn btn-sm btn-primary" (click)="imprimir()">Imprimir</button>
    <button class="btn btn-sm btn-primary mr-5" (click)="copiarExame()"
      [disabled]="marcacaoAtual.status_Atendimento !== 7 && marcacaoAtual.status_Atendimento !== 6" title="Copia o pedido de exame deste atendimento.">
      <i class="fa fa-clipboard"></i> Copiar
    </button>
    <button class="btn btn-sm btn-primary mr-5" (click)="colarExame()"
      [disabled]="!exameCopiado || marcacaoAtual.status_Atendimento !== 5"
      title="Cola o pedido de exame copiado da última consulta FINALIZADA.">
      <i class="fa fa-paste"></i> Colar
    </button>
  </div>
  
  <div class="container-fluid mb-2 text-left">
    <div class="row">
      <div class="col-12">
        <label class="font-weight-bold">Exames Solicitados</label>
        <div *ngIf="marcacaoAtual.isTravada" class="form-control" style="height: auto; min-height: 38px;" [innerHTML]="pedido_Exames_SafeHtml"></div>
        <ng-select *ngIf="!marcacaoAtual.isTravada" [items]="examesDisponiveis" [multiple]="true" [searchable]="true"
          placeholder="Selecione os exames" [(ngModel)]="examesSelecionados" (change)="onExamesChange($event)"
          [closeOnSelect]="false" [clearable]="true" class="exames-empilhados">
        </ng-select>
      </div>
    </div>

    <div class="row mt-3">
      <div class="col-12">
        <label class="font-weight-bold">Observação / Justificativa</label>
        
        <div *ngIf="marcacaoAtual.isTravada" class="form-control" style="height: auto; min-height: 60px; white-space: pre-wrap;">{{ marcacaoAtual.observacao_Exames || 'Nenhuma observação registrada.' }}</div>
        
        <textarea *ngIf="!marcacaoAtual.isTravada" class="form-control" rows="3"
          [(ngModel)]="marcacaoAtual.observacao_Exames"
          placeholder="Digite a justificativa ou observação caso necessário..."></textarea>
      </div>
    </div>
  </div>
</fieldset>